var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"language-main"},[_c('span',{staticClass:"language-text"},[_vm._v("简体中文")]),_c('i',{staticClass:"drop-down"})])}]

export { render, staticRenderFns }